import { IPinPoolIndivdiual } from "../../models/cardgroup.interface";
import { removePinPoolNumber } from "../forms/cardGroups/pinPool/pin-pool-helpers";
import { generator } from "../../helpers/helpers";
import { PIN_POOL_FORM } from "../forms/cardGroups/form-cardgroup-types";

/**
 * Widget to display a list of Pin that can be removed from a Card Group
 * 
 * @param {any} pinPoolList the card group list array
 * @param {HTMLElement} container the parent container for the generated list of elements
 * 
 * @returns void
 */
export const pinPoolWidget = ( pinPoolList: Array<IPinPoolIndivdiual>, container: HTMLElement ) => {
  if (!Array.isArray(pinPoolList) || pinPoolList.length === 0 || !container) return {};

  const gen = generator();

  pinPoolList.forEach((item: IPinPoolIndivdiual) => {    
    const id = gen.next().value;

    const div = document.createElement('div');
    div.className = `pin-pool-widget key_${id}`; 
    div.id = `aafp_container-${id}`; 
    div.setAttribute('data-pin-number', String(id));      

    const divInnerLeft = document.createElement('div');
    divInnerLeft.className = 'pin-input';

    const pinNumberInput = document.createElement('input');
    pinNumberInput.type = 'number';
    pinNumberInput.className = 'aafp_input aafp_color-theme-input pin_number form-control';
    pinNumberInput.id = `aafp_pin-number-${id}`;
    pinNumberInput.value = String(item.validValue);
    pinNumberInput.dataset.pin = String(item.validValue);
    pinNumberInput.required = true;

    const divInnerMiddle = document.createElement('div');
    divInnerMiddle.className = 'pin-description';

    const pinDescriptionInput = document.createElement('input');
    pinDescriptionInput.type = 'text';
    pinDescriptionInput.className = 'aafp_input aafp_color-theme-input form-control pin-desc';
    pinDescriptionInput.id = `aafp_pin-description-${item.validValue}`;
    pinDescriptionInput.value = item.description === 'null' ? '' : item.description;
    pinDescriptionInput.placeholder = 'Pin Description (Optional)';
    pinDescriptionInput.oninput = function(e) {
      const input = e.target as HTMLInputElement;
      input.value = input.value.replace(/[^a-zA-Z0-9 ]/g, '');
    }
    pinDescriptionInput.maxLength = 127;

    const divInnerRight = document.createElement('div');
    divInnerRight.className = 'pin-remove';

    const pinButton = document.createElement('i');
    pinButton.className = `far fa-trash-alt element-remove-${id}`;
    pinButton.dataset.toggle = 'tooltip';
    pinButton.dataset.placement = 'bottom';
    pinButton.dataset.title = `Remove ${item.validValue}`;


    divInnerLeft.appendChild(pinNumberInput);
    divInnerMiddle.appendChild(pinDescriptionInput);
    divInnerRight.appendChild(pinButton);
    div.appendChild(divInnerLeft);
    div.appendChild(divInnerMiddle);
    div.appendChild(divInnerRight);

    if ( pinPoolList.length > 1 ) {
      container.appendChild(div);  
    } else {
      container.prepend(div);  
    }

    removePinPoolNumber(`.element-remove-${id}`, String(id));
  });
}